import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    skeleton: {
      width: '100%',
    },
  }),
);

export default useStyles;
